import { NESTED_PROPERTY_DELIMITER } from '../index';

export const nested = (properties: string[]): string => {
  return properties.join(NESTED_PROPERTY_DELIMITER);
};
